import { render, staticRenderFns } from "./PurchasesInvoicesTitle.vue?vue&type=template&id=c78644ce&scoped=true"
import script from "./PurchasesInvoicesTitle.vue?vue&type=script&lang=js"
export * from "./PurchasesInvoicesTitle.vue?vue&type=script&lang=js"
import style0 from "./PurchasesInvoicesTitle.vue?vue&type=style&index=0&id=c78644ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78644ce",
  null
  
)

export default component.exports